import React, { useState } from "react";

import axios from "axios";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import ReCAPTCHA from "react-google-recaptcha";
export default function ForgotPasswordModal({ cancelModal }) {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [capVal, setCapVal] = useState(null); 
  //styled
  const handleClick = async () => {
    if(capVal){
    function formatEmailForURL(e) {
      // Replace "@" with "%40"
      return e.replace("@", "%40");
    }

    setIsLoading(true);
    const response = await axios.post(
      `${ApiConnectionString}/api/ForgotPasswordToken?email=${formatEmailForURL(
        email
      )}`
    );
    setEmail("");
    setSubmitted(true);
    setIsLoading(false);

  }
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  if (!isLoading) {
    return (
      <div className="send-modal-overlay">
        {!submitted ? (
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">
                Forgotten your pasword
              </p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>We will email you a link to reset your password.</p>
            <div className="send-modal-body">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleInputChange}
                className="modal-input"
              />
              <div className="m-3">
              <ReCAPTCHA
                sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
                onChange={(val) => setCapVal(val)}
              />
            </div>
            </div>
            <div className="send-modal-footer">
          {capVal &&    <button className="saveChanges-button mx-3" onClick={handleClick}>
                 Send password reset link
              </button>}
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">
                Password reset link sent
              </p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>
              An email with the link to reset your password has been sent,
              provided that your email address exists in the system.
            </p>

            <div className="send-modal-body"></div>
            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-body"></div>
        </div>
      </div>
    );
  }
}
